// Legacy imports can leave the sole capable role without a primary flag.
// Use the same fallback in the roster and editor, without guessing between roles.
export function getEmployeeMainRole(roles = []) {
  const activeRoles = (roles || []).filter((role) => !role.is_archived);
  return (
    activeRoles.find((role) => role.main_role_ind === 1) ||
    (activeRoles.length === 1 ? activeRoles[0] : null)
  );
}
